import useAddressSuggestions from './AddressSuggestionsHook';

export default useAddressSuggestions;
